module.exports = __webpack_public_path__ + "assets/ic-shake.a119ff1c.svg";